export const IMGIX_HOST = process?.env?.["NEXT_PUBLIC_IMGIX_HOST"] as string;

interface ImgixParams {
  /**
   * defaults to faces,edges
   */
  crop?: string;

  fit?: string;

  /**
   * maps to fp-x
   */
  fp_x?: string;

  /**
   * maps to fp-y
   */
  fp_y?: string;

  /**
   * maps to fp-z
   */
  fp_z?: string;
}

interface shapeImgixParamsResult {
  crop: string | undefined;
  fit: string | undefined;
  "fp-x": string | undefined;
  "fp-y": string | undefined;
  "fp-z": string | undefined;
  q: 50;
}

/**
 * given an object
 * return a properly shaped imxix param
 */
export const shapeImgixParams = (obj: ImgixParams): shapeImgixParamsResult => {
  return {
    crop: obj?.crop || "faces,edges",
    fit: obj?.fit,
    "fp-x": obj?.fp_x,
    "fp-y": obj?.fp_y,
    "fp-z": obj?.fp_z,
    q: 50,
  };
};

/**
 * Determines whether an image is imgix or not
 */
export const isImgix = (imgUrl?: string) => {
  if (imgUrl?.includes("imgix")) return true;

  return false;
};
